export const openCloseMotion = {
	open: {
		height: 'auto',
		opacity: 1,
		transition: {
			duration: 0.3,
			ease: 'easeInOut',
		},
	},
	closed: {
		height: 0,
		opacity: 0,
		overflow: 'hidden',
		transition: {
			duration: 0.3,
			ease: 'easeInOut',
		},
	},
};
